<app-header></app-header>
<ngx-ui-loader></ngx-ui-loader>
<!-- src/app/app.component.html -->
<div *ngIf="loading" class="loader-overlay">
            <div class="scene">
                <div class="cube-wrapper">
                    <div class="cube">
                    <div class="cube-faces">
                        <div class="cube-face shadow"></div>
                        <div class="cube-face bottom"></div>
                        <div class="cube-face top"></div>
                        <div class="cube-face left"></div>
                        <div class="cube-face right"></div>
                        <div class="cube-face back"></div>
                        <div class="cube-face front"></div>
                    </div>
                    </div>
                </div>
            </div>
</div>
<router-outlet (activate)="onRouteActivate()"></router-outlet>
<app-footer *ngIf="showFooter"></app-footer>
<app-logout-modal  [isLogoutActive]="true"></app-logout-modal> 